import { render } from "./OsiLiftovi.vue?vue&type=template&id=c84982a6&scoped=true"
import script from "./OsiLiftovi.vue?vue&type=script&lang=js"
export * from "./OsiLiftovi.vue?vue&type=script&lang=js"

import "./OsiLiftovi.vue?vue&type=style&index=0&id=c84982a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84982a6"]])

export default __exports__